// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace BillableItemIds {
  export enum Plan {
    TrialPackageUsdMonthly = 'Trial-Package-USD-Monthly',
    ClosedBetaPackageUsdMonthly = 'Closed-Beta-Package-USD-Monthly',
    StarterPlanUsdMonthly = 'Starter-Plan-USD-Monthly',
    StarterPlanUsdYearly = 'Starter-Plan-USD-Yearly',
    GrowthPlanUsdMonthly = 'Growth-Plan-USD-Monthly',
    GrowthPlanUsdYearly = 'Growth-Plan-USD-Yearly',
    PremiumPlanUsdMonthly = 'Premium-Plan-USD-Monthly',
    PremiumPlanUsdYearly = 'Premium-Plan-USD-Yearly',

    StarterUsdMonthly = 'Starter-USD-Monthly',
    StarterUsdYearly = 'Starter-USD-Yearly',
    GrowthUsdMonthly = 'Growth-USD-Monthly',
    GrowthUsdYearly = 'Growth-USD-Yearly',
    FreeUsdMonthly = 'Free-USD-Monthly',
    ProUsdMonthly = 'Pro-USD-Monthly',
    ProUsdYearly = 'Pro-USD-Yearly'
  }
  export enum Custom {
    Enterprise = 'Enterprise'
  }
  export enum Addon {
    SmsRecurringUsdMonthly = 'SMS-Recurring-USD-Monthly',
    SmsRecurringUsdYearly = 'SMS-Recurring-USD-Yearly',
    RecurringSmsTextCreditsUsdMonthly = 'Recurring-sms-text-credits-USD-Monthly',
    RecurringSmsTextCreditsUsdYearly = 'Recurring-sms-text-credits-USD-Yearly',

    RecurringStarterSmsTextCreditsUsdMonthly = 'Recurring-Starter-sms-text-credits-USD-Monthly',
    RecurringStarterSmsTextCreditsUsdYearly = 'Recurring-Starter-sms-text-credits-USD-Yearly',

    RecurringGrowthSmsTextCreditsUsdMonthly = 'Recurring-Growth-sms-text-credits-USD-Monthly',
    RecurringGrowthSmsTextCreditsUsdYearly = 'Recurring-Growth-sms-text-credits-USD-Yearly',

    RecurringProSmsTextCreditsUsdMonthly = 'Recurring-Pro-sms-text-credits-USD-Monthly',
    RecurringProSmsTextCreditsUsdYearly = 'Recurring-Pro-sms-text-credits-USD-Yearly',

    RecurringFreemiumSmsTextCreditsUsdMonthly = 'Recurring-Freemium-sms-text-credits-USD-Monthly'
  }

  export enum Charge {
    PayAsYouGoSmsBundleOnceOffUsd = 'Pay-as-you-go-SMS-bundle-once-off-USD',

    PayAsYouGoTextCreditsOnceOffFreemiumUsd = 'Pay-as-you-go-text-credits-Freemium-USD',
    PayAsYouGoTextCreditsOnceOffStarterUsd = 'Pay-as-you-go-text-credits-Starter-USD',
    PayAsYouGoTextCreditsOnceOffGrowthUsd = 'Pay-as-you-go-text-credits-Growth-USD',
    PayAsYouGoTextCreditsOnceOffProUsd = 'Pay-as-you-go-text-credits-Pro-USD',

    ShopifyGrowthPayAsYouGoSmsBundleOnceOffUsd = 'Shopify-growth-pay-as-you-go-SMS-bundle-once-off-USD',
    ShopifyFreemiumPayAsYouGoSmsBundleOnceOffUsd = 'Shopify-freemium-pay-as-you-go-SMS-bundle-once-off-USD',

    PhoneNumberLookupUsd = 'Phone-number-lookup-USD'
  }
  export enum TelkomPlan {
    TelkomStarterMonthly = 'Telkom-Starter-Monthly',
    TelkomBasicMonthly = 'Telkom-Basic-Monthly',
    TelkomProMonthly = 'Telkom-Pro-Monthly',
    TelkomFreemium = 'Telkom-Freemium'
  }
  export enum AppSumoPlan {
    MobizTier1 = 'mobiz_tier1',
    MobizTier2 = 'mobiz_tier2',
    MobizTier3 = 'mobiz_tier3',
    MobizTier4 = 'mobiz_tier4'
  }

  export enum ShopifyPlan {
    ShopifyFreeMonthly = 'Shopify-Free-Monthly',
    ShopifyPaidMonthly = 'Shopify-Paid-Monthly'
  }

  export type All =
    | BillableItemIds.Plan
    | BillableItemIds.Addon
    | BillableItemIds.TelkomPlan
    | BillableItemIds.AppSumoPlan
    | BillableItemIds.Custom
    | BillableItemIds.Charge
    | BillableItemIds.ShopifyPlan;
}
export enum BillableItemType {
  Plan = 'plan',
  Addon = 'addon',
  Charge = 'charge',
  Custom = 'custom',
  TelkomPlan = 'telkomPlan',
  AppSumoPlan = 'appSumoPlan',
  ShopifyPlan = 'shopifyPlan'
}
export enum BillableItemStatus {
  Active = 'active',
  Archived = 'archived'
}
export enum BillableItemPaymentModel {
  Monthly = 'monthly',
  Yearly = 'yearly',
  Trial = 'trial',
  OneTime = 'oneTime',
  Custom = 'custom',
  Freemium = 'freemium',
  Lifetime = 'lifetime'
}
export enum FeatureType {
  Contact = 'contact',
  Sms = 'sms',
  PersonalisedLandingPage = 'personalisedLandingPage',
  DynamicTemplate = 'dynamicTemplate',
  SubscriberGrowthTool = 'subscriberGrowthTool',
  TollFreeNumber = 'tollFreeNumber',
  BulkContactUpload = 'bulkContactUpload',
  BundledSmsCreditCost = 'bundledSmsCreditCost',
  PayAsYouGoSmsCreditCost = 'payAsYouGoSmsCreditCost',
  PictureMessaging = 'pictureMessaging',
  MmsTextOverlay = 'mmsTextOverlay',
  ApiAutomationCampaign = 'apiAutomationCampaign',
  BundledMmsCreditCost = 'bundledMmsCreditCost',
  CustomDomain = 'customDomain',
  Automation = 'automation',
  NumberLookupUnitCost = 'numberLookupUnitCost',
  NumberLookupMinimumCost = 'numberLookupMinimumCost',

  HelpDocuments = 'helpDocuments',
  EmailChatSupport = 'emailChatSupport',
  ZapierIntegrations = 'zapierIntegrations',
  OnBoardingLaunch = 'onBoardingLaunch',
  UniqueVerifiedLocalNumber = 'uniqueVerifiedLocalNumber',
  CustomIntegrations = 'customIntegrations',
  PriorityEmailLiveSupport = 'priorityEmailLiveSupport',
  PriorityCallSupport = 'priorityCallSupport'
}
export enum CurrencyCode {
  ZAR = 'ZAR',
  USD = 'USD'
}
